import { Directive, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { NgForm }   from '@angular/forms';
@Directive({
  selector: '[FormSubmitValidation]'
})
export class FormSubmitValidationDirective {


  
  @Output ('FormSubmitValidation') valid= new EventEmitter<void>();
  constructor(private formRef: NgForm) {

   }
   @HostListener('click')
   handleClick(){
     this.markFieldAsTouched();
     this.emitIfValid();
   }
   private markFieldAsTouched(){
     Object.keys(this.formRef.controls)
     .forEach(fieldName=>{
       this.formRef.controls[fieldName].markAsTouched()
     });
   }
   private emitIfValid(){
     if(this.formRef.valid){
       this.valid.emit();
     }
   }

}
